module.exports = __webpack_public_path__ + "img/Suanx.96e26864.svg";